/**
 * Ko plugin to create trackableObserver
 */
define('customPlugins/koTrackableObservable',[
        'knockout', 'lodash', 'jquery', './registerTrackableObservable',
        'durandal/system', 'kendo-knockout',
    ],
    function(ko, _, $, registerTrackableObservable, system) {
        'use strict';
        /**
         * Utility function to create computed array
         * @return {ko.computed} ko.observable with some array like properties
         */
        ko.computedArray = function() {
            var computed = ko.computed.apply(this, arguments);
            ko.utils.arrayForEach(
                ['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'],
                function(methodName) {
                    computed[methodName] = function() {
                        var underlyingArray = computed();
                        underlyingArray[methodName].apply(underlyingArray, arguments);
                        computed(underlyingArray);
                    };
                }
            );
            return computed;
        };
        /**
         * Plugin to create ko trackableObserver. This observer is designed to
         * track changes in values and has additional functionality to reset
         * the observer itself
         * @param  {JSON/Ko.observable} reference [reference of JSON/ reference observer]
         * @return {ko.Observable}    proxy observable
         */
        ko.trackableObservable = function(reference, functionName) {
            if (ko.isObservable(reference)) {
                var observable = getTrackableObsFromObs(reference, functionName);
                return observable;
            } else {
                throw 'Observer expected @ koTrackableObserver';
            }
        };
        /**
         * Performs the shallow copy of mapped Source Observable to
         * mapped Destination Observable
         *
         * @param  {ko.Observable} obsSrc  Mapped source Observable
         * @param  {ko.Observable} obsDest Mapped Destination Observable
         * @return {undefined}
         */
        ko.shallowCopy = function(obsSrc, obsDest) {
            shallowCopyObj(obsSrc(), obsDest());
        };

        function shallowCopyObj(obsObjSrc, obsObjDest) {
            _.forOwn(obsObjSrc, function(observable, observableName) {
                if ('__ko_mapping__' !== observableName) {
                    if (_.isFunction(obsObjDest[observableName]) && _.isFunction(observable)) {
                        if (_.isArray(observable())) {
                            obsObjDest[observableName](_.clone(observable(), true));
                        } else {
                            obsObjDest[observableName](observable());
                        }
                    } else if (_.isObject(obsObjDest[observableName]) && _.isObject(observable)) {
                        shallowCopyObj(observable, obsObjDest[observableName]);
                    }
                }
            });
        }

        /**
         * Performs the shallow copy of mapped Source Observable to
         * mapped Destination Observable
         *
         * @param  {ko.Observable} obsSrc  Mapped source Observable
         * @param  {ko.Observable} obsDest Mapped Destination Observable
         * @return {undefined}
         */
        ko.shallowCopy2 = function(obsSrc, obsDest) {
            shallowCopyObj2(obsSrc(), obsDest());
        };

        function shallowCopyObj2(obsObjSrc, obsObjDest) {
            _.forOwn(obsObjSrc, function(observable, observableName) {
                if ('__ko_mapping__' !== observableName) {
                    if (_.isFunction(obsObjDest[observableName]) && _.isFunction(observable)) {
                        if (_.isArray(observable()) && _.isArray(obsObjDest[observableName]())) {
                            var source = observable(),
                                dest = obsObjDest[observableName]();

                            shallowCopyArray(source, dest);

                            obsObjDest[observableName](dest);

                        } else {
                            obsObjDest[observableName](observable());
                        }
                    } else if (_.isObject(obsObjDest[observableName]) && _.isObject(observable)) {
                        shallowCopyObj2(observable, obsObjDest[observableName]);
                    }
                }
            });
        }

        function shallowCopyArray(source, dest) {
            var length = _.min([source.length, dest.length]),
                sourceItem, destItem, index;
            for (index = 0; index < length; index++) {
                sourceItem = source[index];
                destItem = dest[index];
                if (_.isObject(sourceItem) && _.isObject(destItem)) {
                    shallowCopyObj2(sourceItem, destItem);
                } else if (!_.isObject(sourceItem) && !_.isObject(destItem)) {
                    dest[index] = sourceItem;
                } else {
                    throw 'Something wierd is going on in shallowCopyObj2';
                }
            }
            if (dest.length > source.length) {
                dest.splice(source.length, dest.length - source.length);
            } else if (source.length > dest.length) {
                for (index = dest.length; index < source.length; index++) {
                    dest[index] = ko.mapping.fromJS(ko.mapping.toJS(source[index]));
                }
            }
        }

        function getCopyFn(key) {
            var copyFn = {
                '_default': ko.shallowCopy,
                'array': ko.shallowCopy2
            };
            return copyFn[key] || copyFn._default;
        }

        /**
         * function to create trackable observable from a mapped ko.observable
         * @param  {ko.observable} observable passed reference ko.observable
         * @return {ko.observable}            proxy observable
         */
        function getTrackableObsFromObs(observable, functionName) {
            var created = false;
            var copy = getCopyFn(functionName);
            /**
             * the actual observable containing the commited value
             * @type {ko.observable}
             */
            var committedValue = observable;
            /**
             * the proxy variable/observable given form making changes
             * @type {ko.observable}
             */
            var result = ko.observable(null);
            /**
             * variable to force equality of commitedValue and result
             * @type {Boolean}
             */
            var isEqual = ko.observable(false);
            /**
             * gives if the current trackableObservable is Pristine or not
             * @return {boolean} trackableObservable is Pristine or not
             *
             * Note: Yet to be tested
             */
            result.isPristine = ko.computed({
                read: function() {
                    isEqual(isEqual() && _.isEqual(ko.mapping.toJS(result), ko.mapping.toJS(committedValue)));
                    return isEqual();
                },
                deferEvaluation: true
            });
            /**
             * returns the commited value
             * @return {ko.observable} commited value of the trackable observable
             */
            result.getCommitedValue = function() {
                return committedValue();
            };
            /**
             * commits the current value of trackableObservable
             * @return {undefined}
             */
            result.commit = function() {
                copy(result, committedValue);
                isEqual(true);
            };
            /**
             * resets the trackableObservable to its commited value
             * @return {undefined}
             */
            result.reset = function() {
                copy(committedValue, result);
                isEqual(true);
            };
            /**
             * Initializes the trackable observer with initial value of commitedValue
             * @return {undefined}
             */
            result.init = function() {
                if (!created) {
                    if (committedValue()) {
                        result(ko.mapping.fromJS(ko.mapping.toJS(committedValue)));
                    } else {
                        result(committedValue());
                    }
                    isEqual(true);
                    created = true;
                    registerTrackableObservable.addTrackableObs(result);
                }
            };
            result.save = function() {
                system.error('Original save function is not specified');
            };
            return result;
        }
    });
